/**
 * =============<< ********* >>=============
 * Author       : Tony NGUEREZA
 * Email        : nguerezatony@gmail.com
 * Organization : Quantum Software Foundation Ltd.
 * Created On   : 2025-09-29
 * Title        :
 * Description  :
 * Copyright (c) 2025 Quantum Software Foundation Ltd..
 * =============<< ********* >>=============
 */
import { apiURL } from '../helpers/api-url';
import AuthHelper from '../helpers/auth-helper';
import api from './api';

export async function renewUserToken(){
    const refreshToken = AuthHelper.getRefreshToken();
    if(refreshToken.length <= 0){
        return {};
    }
    const result = await api.post(apiURL.refreshToken, {refresh_token: refreshToken});
    return result.data?.data || {};
}